import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withClinicalData } from '../contexts/clinicalData';

import QALayout from '../layout/QA';
import Questionnaire from '../components/Questionnaire';

import Clipboard from 'images/ask/icons/clipboard.svg';

//import SegmentAnalytics from '../../../helpers/SegmentAnalytics.js';

class QA extends Component {
  constructor(props) {
    super(props);

    this.state = this.resolveState(props);
  }

  resolveState(props) {
    const clinicalData = props.clinicalData;
    const questions = clinicalData.qa.nextQuestions;

    clinicalData.clearQaAnswersForQuestions(questions);

    const answers = clinicalData.qa.answers;

    return { submitting: false, answers, questions };
  }

  UNSAFE_componentWillReceiveProps(props) {
    // In order to pop a question when the back button is used. Note that this only works for as long as the backend
    // only sends a single question at a time; it'll malfunction if an array of questions is sent. The handlers are
    // not prepared for that.
    if (props.history.action === 'POP') {
      props.clinicalData.popQaQuestion();
    }

    this.setState(this.resolveState(props));
  }

  render() {
    const { answers, questions, submitting } = this.state;
    const { history } = this.props;

    return (
      <QALayout
        className="qa-view"
        completionPercentage={80}
        sidebar={
          <React.Fragment>
            <img className="header-icon" src={Clipboard} />
            <h2>A little more information</h2>
            <p>This information will help us narrow down possible conditions and give you more accurate results.</p>
          </React.Fragment>
        }
        content={
          <Questionnaire
            answers={answers}
            questions={questions}
            onButtonNext={this.onButtonNext.bind(this)}
            onButtonPrevious={history.goBack}
            autoSubmit={true}
            submitting={submitting}
            hideNavigator={true}
          />
        }
      />
    );
  }

  onButtonNext(data) {
    this.setState({ submitting: true });
    this.props.clinicalData.setQaAnswers(data);
  }
}

QA.defaultProps = {};

QA.propTypes = {
  clinicalData: PropTypes.object.isRequired,
  history: PropTypes.object
};

export { QA };
export default withClinicalData(QA);
